/* 7 O'CLOCK – Streichpreis (UVP / Vergleichspreis) im Warenkorb, 07.10.2026
   Für jede Warenkorb-Zeile mit Vergleichspreis über dem Preis: UVP × Menge durchgestrichen, aktueller Preis rot.
   Daten: /products/<handle>.js (compare_at_price der Variante), Zeile über Alpine.$data(li).product.
   Eingebunden über snippets/gtm-head.liquid. Bestehende Rabatt-Anzeige (automatische Rabatte) bleibt, wenn kein UVP da ist. */
(function () {
  'use strict';
  var cache = {}, loading = {}, pending = false;

  function money(c) {
    var s = (Math.round(c) / 100).toFixed(2).split('.');
    return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + s[1] + ' €';
  }
  function load(handle) {
    if (cache[handle] || loading[handle]) return;
    loading[handle] = true;
    fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var m = {};
        if (p && p.variants) p.variants.forEach(function (v) { if (v.compare_at_price) m[v.id] = v.compare_at_price; });
        cache[handle] = m; schedule();
      })
      .catch(function () { cache[handle] = {}; });
  }
  function apply() {
    pending = false;
    if (!window.Alpine || !window.Alpine.$data) return;
    document.querySelectorAll('.mini-cart_item').forEach(function (li) {
      var box = li.querySelector('.mini-cart_price');
      if (!box) return;
      var p; try { p = window.Alpine.$data(li).product; } catch (e) { p = null; }
      if (!p || p.isCrossBundle || !p.handle || !p.variant_id) return;
      if (!cache[p.handle]) { load(p.handle); return; }
      var cmp = cache[p.handle][p.variant_id] || 0;
      var wasLine = cmp * (p.quantity || 1);
      var mine = box.querySelector('.oc-cmp');
      if (cmp && wasLine > p.line_price) {
        if (!mine) {
          mine = document.createElement('div');
          mine.className = 'mini-cart_compare-at-price oc-cmp';
          mine.appendChild(document.createElement('div'));
          box.insertBefore(mine, box.firstChild);
        }
        var txt = money(wasLine);
        if (mine.firstChild.textContent !== txt) mine.firstChild.textContent = txt;
        box.classList.add('oc-has-cmp');
      } else {
        if (mine) mine.remove();
        box.classList.remove('oc-has-cmp');
      }
    });
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(apply); } }

  var st = document.createElement('style');
  st.textContent =
    '.mini-cart_price.oc-has-cmp > .mini-cart_compare-at-price:not(.oc-cmp){display:none !important}' +
    '.mini-cart_price.oc-has-cmp > div:last-child{color:var(--base-color-brand--red, #c13c3c) !important}';
  document.head.appendChild(st);

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        var el = t.nodeType === 1 ? t : t.parentElement;
        if (el && el.closest && el.closest('.oc-cmp')) continue;
        schedule(); return;
      }
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('cartupdated', function () { setTimeout(schedule, 300); });
})();
